import {
  Box,
  Container,
  Grid,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
  makeStyles,
} from "@material-ui/core";
import {
  CancelButton,
  CircularProggressIndicator,
  SubmitButton,
} from "../components-atoms";
import {
  ErrorModal,
  GeneralModal,
  HeaderWithButtons,
  InfoBox,
  InfoLine,
  RemoveImageModal,
} from "../components-molecules";
import { HttpRegularDelete, HttpRegularPost, HttpRegularPut } from "../service";
import { MuiPickersUtilsProvider, TimePicker } from "@material-ui/pickers";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";

import CssBaseline from "@material-ui/core/CssBaseline";
import DateFnsUtils from "@date-io/date-fns";
import { ITheme } from "../constants/theme";
import RemoveCircleOutlineIcon from "@material-ui/icons/RemoveCircleOutline";
import ClearIcon from "@material-ui/icons/Clear";
import { clearshopDetails, getShopDetailsLegacy } from "../redux/actions/shopDetails";
import moment from "moment";
import momentTz from "moment-timezone";
import upload from "../assets/icons/upload.svg";
import { EMAIL_PATTERN } from "../constants/validation";
import { buttonHoverAndActive, textButtonHoverAndActive } from "../utils/styles/buttonStyles";

interface ShopFormI {
  Name?: string;
  Line1?: string;
  Line2?: string;
  PostalCode?: string;
  City?: string;
  County?: string;
}
const sampleHours = [1, 2, 3, 4, 5, 6, 7].map((item: number) => {
  return {
    Day: item,
    StartTime: undefined,
    EndTime: undefined,
  };
});
const imageTypes: string[] = ["png", "jpg", "jpeg"];

export const ShopDetails = (props: any) => {
  const classes = useStyles();
  const history = useHistory();
  const params: any = useParams();
  const dispatch = useDispatch();
  const days = [
    "MONDAY",
    "TUESDAY",
    "WEDNESDAY",
    "THURSDAY",
    "FRIDAY",
    "SATURDAY",
    "SUNDAY",
  ];

  const [name, setName] = useState("");
  const [address, setAddress] = useState<ShopFormI>({});
  const [manager, setManager] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [pickingHours, setPickingHours] = useState<
    Array<{
      Day?: number;
      Id?: string;
      StartTime?: Date | string;
      EndTime?: Date | string;
    }>
  >([]);
  const [editType, setEditType] = useState("");
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [deleteImageModalOpen, setDeleteImageModalOpen] =
    useState<boolean>(false);
  const [imageId, setImageId] = useState<string>("");
  const [errorModalOpen, setErrorModalOpen] = useState<boolean>(false);
  const [emailError, setEmailError] = useState(false);
  const [phoneError, setPhoneError] = useState(false);

  useEffect(() => {
    dispatch(getShopDetailsLegacy(params?.id));
    return () => {
      dispatch(clearshopDetails());
    };
  }, []); // eslint-disable-line

  const shopDetailsLoading = useSelector(
    (state: any) => state.shopDetails.loading
  );

  const data = useSelector((state: any) => state.shopDetails.data);

  const handleAddressChange =
    (field: string) => (event: React.ChangeEvent<HTMLInputElement>) => {
      setAddress({
        ...address,
        [field]: event.target.value,
      });
    };
  function compare(a: any, b: any) {
    if (a.Day < b.Day) {
      return -1;
    }
    if (a.Day > b.Day) {
      return 1;
    }
    return 0;
  }

  const sortAndSetPickingHours = () => {
    let sortedPickingHours = [...sampleHours];
    if (data?.PickingHours && data.PickingHours.length > 0) {
      sortedPickingHours = data?.PickingHours?.sort(compare);
      setPickingHours(sortedPickingHours);
    }
  };

  useEffect(() => {
    sortAndSetPickingHours();
    setName(data?.Name ?? "");
    setManager(data?.Manager ?? "");
    setEmail(data?.Email ?? "");
    setPhone(data?.Phone ?? "");
    setAddress(data?.Address ?? {});

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  const TimeModalBody = () => {
    const timePickerValue = (value: string | null | Date | undefined) => {
      if (value) {
        const time = momentTz.utc(value).tz("Europe/London").format();
        return time;
      }
      return null;
    };

    const dateClearClicked = (e: any, index: number, time: "start" | "end") => {
      e.stopPropagation();
      e.preventDefault();
      let temp = [...JSON.parse(JSON.stringify(pickingHours))];
      const listIndex = temp.findIndex((item) => item?.Day === index);

      if (temp?.[listIndex]) {
        switch (time) {
          case "start":
            temp[listIndex].StartTime = undefined;
            if (
              !temp[listIndex]?.EndTime ||
              temp[listIndex]?.EndTime === undefined
            ) {
              temp = JSON.parse(
                JSON.stringify(
                  pickingHours.filter((item) => item?.Day !== index)
                )
              );
            }
            break;
          case "end":
            temp[listIndex].EndTime = undefined;
            if (
              !temp[listIndex]?.StartTime ||
              temp[listIndex]?.StartTime === undefined
            ) {
              temp = JSON.parse(
                JSON.stringify(
                  pickingHours.filter((item) => item?.Day !== index)
                )
              );
            }
            break;
          default:
            break;
        }
      } else {
        temp[listIndex] = { ...sampleHours[listIndex] };
        switch (time) {
          case "start":
            temp[listIndex].StartTime = undefined;
            break;
          case "end":
            temp[listIndex].EndTime = undefined;
            break;
          default:
            break;
        }
      }

      setPickingHours(temp);
    };

    const getPickingHourStartTime = (index: number) => {
      const result = pickingHours.filter((item) => item?.Day === index);
      return result[0]?.StartTime ? result[0].StartTime : undefined;
    };
    const getPickingHourEndTime = (index: number) => {
      const result = pickingHours.filter((item) => item?.Day === index);
      return result[0]?.EndTime ? result[0].EndTime : undefined;
    };

    return [
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
      "Sunday",
    ].map((item: any, index: number) => (
      <Grid
        container
        spacing={4}
        key={index}
        className={index === 0 ? classes.uMarginTop0 : ""}
      >
        <Grid item xs={6}>
          <TimePicker
            variant="dialog"
            value={timePickerValue(getPickingHourStartTime(index + 1))}
            inputVariant="outlined"
            InputProps={{
              endAdornment: (
                <InputAdornment position={"end"}>
                  {timePickerValue(getPickingHourStartTime(index + 1)) ? (
                    <IconButton
                      data-automation="clear"
                      className={classes.clearButton}
                      onClick={(e) => {
                        dateClearClicked(e, index + 1, "start");
                      }}
                    >
                      <ClearIcon
                        htmlColor="rgba(0,0,0,0.54)"
                        className={classes.clearIcon}
                      />
                    </IconButton>
                  ) : (
                    <div className={classes.clearButton}></div>
                  )}
                </InputAdornment>
              ),
            }}
            label={item + " from"}
            onChange={(val: any) => {
              const utcVal = moment(val).utc().format();
              const temp = [...pickingHours];
              if (temp?.[index]) temp[index].StartTime = utcVal;
              else {
                temp[index] = { ...sampleHours[index] };
                temp[index].StartTime = utcVal;
              }

              setPickingHours(temp);
            }}
          />
        </Grid>
        <Grid item xs={6}>
          <TimePicker
            variant="dialog"
            inputVariant="outlined"
            label={item + " to"}
            value={timePickerValue(getPickingHourEndTime(index + 1))}
            InputProps={{
              endAdornment: (
                <InputAdornment position={"end"}>
                  {timePickerValue(getPickingHourEndTime(index + 1)) ? (
                    <IconButton
                      data-automation="clear"
                      className={classes.clearButton}
                      onClick={(e) => dateClearClicked(e, index + 1, "end")}
                    >
                      <ClearIcon
                        htmlColor="rgba(0,0,0,0.54)"
                        className={classes.clearIcon}
                      />
                    </IconButton>
                  ) : (
                    <div className={classes.clearButton}></div>
                  )}
                </InputAdornment>
              ),
            }}
            onChange={(val: any) => {
              const utcVal = moment(val).utc().format();
              const temp = [...pickingHours];
              if (temp?.[index]) temp[index].EndTime = utcVal;
              else {
                temp[index] = { ...sampleHours[index] };
                temp[index].EndTime = utcVal;
              }

              setPickingHours(temp);
            }}
          />
        </Grid>
      </Grid>
    ));
  };

  const handleSubmit = () => {
    let url = "/merchant/shop/" + params.id + "/";
    let value: any;
    switch (editType) {
      case "Name":
        url += "name";
        value = { Name: name };
        break;
      case "Address":
        url += "address";
        value = address;
        break;
      case "Manager":
        url += "manager";
        value = { Manager: manager };
        break;
      case "Email":
        if (!EMAIL_PATTERN.test(email)) {
          setEmailError(true);
          return;
        }
        url += "email";
        value = { Email: email };
        break;
      case "Phone":
        url += "phone";
        value = { Phone: phone };
        break;
      case "Time":
        url += "working-hours";

        const newPickingHours: Array<any> = [];
        pickingHours.forEach((item: any) => {
          if (item !== undefined) {
            newPickingHours.push({
              Id: item.Id,
              Day: item.Day,
              StartHour: moment.utc(item.StartTime).hour(),
              StartMinute: moment.utc(item.StartTime).minute(),
              EndHour: moment.utc(item.EndTime).hour(),
              EndMinute: moment.utc(item.EndTime).minute(),
            });
          }
        });

        value = { PickingHours: newPickingHours };
        break;
      default:
      // code block
    }
    dispatch((disp: any) =>
      HttpRegularPut(url, value, {
        dispatch: disp,
        actionSuccess: () => getShopDetailsLegacy(params?.id),
        //actionFailure:
        callback: () => setEditModalOpen(false),
      })
    );
  };

  const handleSubmitImage = (image: File) => {
    if (image) {
      const extension = image.name.split(".").pop();
      if (!imageTypes.some((type) => type === extension)) {
        setErrorModalOpen(true);
        return;
      }
      const data = new FormData();
      data.append("file", image);
      dispatch((disp: any) =>
        HttpRegularPost("/merchant/shop/" + params.id + "/image", data, {
          dispatch: disp,
          actionSuccess: () => getShopDetailsLegacy(params?.id),
        })
      );
    }
  };
  const submitDisabled = () => {
    if (editType === "Time") {
      let disabled = false;
      pickingHours.forEach((item) => {
        if (item === undefined) {
          return;
        }
        if (!item.EndTime || !item.StartTime) {
          disabled = true;
        }
      });
      return disabled;
    }
  };

  const deleteImage = (imageId: string) => {
    dispatch((disp: any) =>
      HttpRegularDelete(`/merchant/shop/${params.id}/image/${imageId}`, {
        dispatch: disp,
        actionSuccess: () => getShopDetailsLegacy(params?.id),
        callback: () => setDeleteImageModalOpen(false),
      })
    );
  };
  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils} locale={""}>
      <Box className={classes.container}>
        <CssBaseline />

        <Container className={classes.root}>
          <HeaderWithButtons
            smallText="Shops"
            title={data?.Name ?? ""}
            noButton
            shopDetailTitleMoreSpacing
            handleBack={() => {
              history.goBack();
            }}
            isShopInactive={data.Archived}
          >
            <HeaderWithButtons.ButtonArea></HeaderWithButtons.ButtonArea>
          </HeaderWithButtons>
          {/** alse || shopDetailsLoading || data.length === 0 ? */}
          {shopDetailsLoading || data.length === 0 ? (
            <CircularProggressIndicator />
          ) : (
            <>
              <Container className={classes.detailsContainer}>
                <InfoBox title="Basic information">
                  <InfoLine
                    name="SHOP NAME"
                    value={data?.Name ? data.Name : "Add shop name"}
                    onClick={() => {
                      setEditType("Name");
                      setModalTitle("Shop Name");
                      setEditModalOpen(true);
                    }}
                    clickable
                  >
                    <InfoLine.ArrowArea></InfoLine.ArrowArea>
                  </InfoLine>
                  <InfoLine
                    name="ADDRESS"
                    value={
                      data?.Address?.Line1 ? data.Address.Line1 : "Add address"
                    }
                    onClick={() => {
                      setModalTitle("Address");
                      setEditType("Address");
                      setEditModalOpen(true);
                    }}
                    clickable
                    hasBorder={false}
                  >
                    <InfoLine.ArrowArea></InfoLine.ArrowArea>
                  </InfoLine>
                </InfoBox>

                <InfoBox title="Contact information">
                  <InfoLine
                    name="MANAGER"
                    value={data?.Manager ? data.Manager : "Add manager"}
                    onClick={() => {
                      setEditType("Manager");
                      setModalTitle("Manager");
                      setEditModalOpen(true);
                    }}
                    clickable
                  >
                    <InfoLine.ArrowArea></InfoLine.ArrowArea>
                  </InfoLine>
                  <InfoLine
                    name="EMAIL"
                    value={data?.Email ? data.Email : "Add email"}
                    onClick={() => {
                      setModalTitle("Email");
                      setEditType("Email");
                      setEditModalOpen(true);
                    }}
                    clickable
                  >
                    <InfoLine.ArrowArea></InfoLine.ArrowArea>
                  </InfoLine>

                  <InfoLine
                    name="PHONE"
                    value={data?.Phone ? data.Phone : "Add phone"}
                    onClick={() => {
                      setModalTitle("Phone");
                      setEditType("Phone");
                      setEditModalOpen(true);
                    }}
                    clickable
                    hasBorder={false}
                  >
                    <InfoLine.ArrowArea></InfoLine.ArrowArea>
                  </InfoLine>
                </InfoBox>

                <InfoBox title="Delivery picking hours">
                  <InfoLine
                    name=""
                    value={
                      "This information will be visible to the TradeKart customers."
                    }
                    onClick={() => {
                      setModalTitle("Opening hours");
                      setEditType("Time");
                      setEditModalOpen(true);
                    }}
                    clickable
                    hasBorder={false}
                  >
                    <InfoLine.ArrowArea></InfoLine.ArrowArea>
                  </InfoLine>

                  {data?.PickingHours &&
                    data?.PickingHours.map((item: any, index: number) => {
                      return (
                        <InfoLine
                          key={item.Id}
                          name={days[item.Day - 1]}
                          value={
                            momentTz
                              .utc(data.PickingHours[index].StartTime)
                              .tz("Europe/London")
                              .format("h:mm A") +
                            " - " +
                            momentTz
                              .utc(data.PickingHours[index].EndTime)
                              .tz("Europe/London")
                              .format("h:mm A")
                          }
                          onClick={() => {}}
                          hasBorder={index !== data.PickingHours.length - 1}
                        />
                      );
                    })}
                </InfoBox>

                <InfoBox title="Images">
                  <Grid container className={classes.uPaddingTop20}>
                    <Grid item xs={8}>
                      <div className={classes.uMarginBottom12}>
                        <Typography
                          variant="body2"
                          component="p"
                          color="textSecondary"
                        >
                          This image will appear in the following order in your
                          TradeKart shop.
                        </Typography>
                      </div>
                      <div className={classes.uMarginBottom12}>
                        <Typography
                          variant="body2"
                          component="p"
                          color="textSecondary"
                        >
                          Images with 4:3 ratio and up to 1200px x 900px
                          resolution look best.
                        </Typography>
                      </div>
                    </Grid>
                    <Grid item xs={4} style={{ textAlign: "right" }}>
                      <label className="custom-file-upload">
                        {/* <img src={printIcon} className={classes.buttonIcon} alt="printIcon" /> */}
                        <Typography
                          variant="button"
                          component="span"
                          color="primary"
                          className={classes.printButtonText}
                        >
                          <img
                            src={upload}
                            alt="Upload"
                            className={classes.uploadIcon}
                          />
                          Upload images
                          <input
                            onChange={(
                              event: React.ChangeEvent<HTMLInputElement>
                            ) => {
                              event.target.files &&
                                handleSubmitImage(event.target.files[0]);
                            }}
                            type="file"
                            accept="image/*"
                            style={{ display: "none" }}
                          />
                        </Typography>
                      </label>
                    </Grid>
                  </Grid>
                  <Container className={classes.imageList}>
                    {data?.Images &&
                      data.Images.map((item: any, index: number) => {
                        return (
                          <label
                            key={item.Id}
                            className={classes.imageContainer}
                            style={{
                              backgroundImage: `url('${item.ImageUrl}')`,
                            }}
                          >
                            <div
                              onClick={() => {
                                setDeleteImageModalOpen(true);
                                setImageId(item.Id);
                              }}
                              className={classes.removeIconContainer}
                            >
                              <RemoveCircleOutlineIcon
                                htmlColor="rgba(0,0,0,0.54)"
                                className={classes.removeIcon}
                              />
                            </div>
                          </label>
                        );
                      })}
                  </Container>
                </InfoBox>

                <GeneralModal
                  visible={editModalOpen}
                  title={modalTitle}
                  description=""
                  onClose={setEditModalOpen}
                >
                  <GeneralModal.ContentArea>
                    {editType === "Address" ? (
                      <>
                        <TextField
                          placeholder="Address Line 1"
                          value={address?.Line1}
                          onChange={handleAddressChange("Line1")}
                          variant="outlined"
                          margin="normal"
                          fullWidth
                          id="Line1"
                          label="Address line 1"
                          name="Line1"
                          autoFocus
                          InputProps={{
                            classes: {
                              root: classes.cssOutlinedInput,
                              focused: classes.cssFocused,
                              notchedOutline: classes.notchedOutline,
                            },
                          }}
                        />
                        <TextField
                          placeholder="Address Line 2"
                          value={address?.Line2}
                          onChange={handleAddressChange("Line2")}
                          variant="outlined"
                          margin="normal"
                          fullWidth
                          id="Line2"
                          label="Address line 2"
                          name="Line2"
                          autoFocus
                          InputProps={{
                            classes: {
                              root: classes.cssOutlinedInput,
                              focused: classes.cssFocused,
                              notchedOutline: classes.notchedOutline,
                            },
                          }}
                        />
                        {/********************* */}
                        <Grid container spacing={3}>
                          <Grid item xs={6}>
                            <TextField
                              placeholder="PostalCode"
                              value={address?.PostalCode}
                              onChange={handleAddressChange("PostalCode")}
                              variant="outlined"
                              margin="normal"
                              fullWidth
                              id="PostalCode"
                              label="Post Code"
                              name="PostalCode"
                              autoFocus
                              InputProps={{
                                classes: {
                                  root: classes.cssOutlinedInput,
                                  focused: classes.cssFocused,
                                  notchedOutline: classes.notchedOutline,
                                },
                              }}
                            />
                          </Grid>
                          <Grid item xs={6}>
                            <TextField
                              placeholder="City"
                              value={address?.City}
                              onChange={handleAddressChange("City")}
                              variant="outlined"
                              margin="normal"
                              fullWidth
                              id="City"
                              label="City"
                              name="City"
                              autoFocus
                              InputProps={{
                                classes: {
                                  root: classes.cssOutlinedInput,
                                  focused: classes.cssFocused,
                                  notchedOutline: classes.notchedOutline,
                                },
                              }}
                            />
                          </Grid>
                        </Grid>
                        {/********************* */}
                        <TextField
                          placeholder="County"
                          value={address?.County}
                          onChange={handleAddressChange("County")}
                          variant="outlined"
                          margin="normal"
                          fullWidth
                          id="County"
                          label="County"
                          name="County"
                          autoFocus
                          InputProps={{
                            classes: {
                              root: classes.cssOutlinedInput,
                              focused: classes.cssFocused,
                              notchedOutline: classes.notchedOutline,
                            },
                          }}
                        />
                        <TextField
                          placeholder="United Kingdom"
                          value="United Kingdom"
                          variant="outlined"
                          margin="normal"
                          fullWidth
                          id="Country"
                          label="Country"
                          name="Country"
                          disabled
                          autoFocus
                          InputProps={{
                            classes: {
                              root: classes.cssOutlinedInput,
                              focused: classes.cssFocused,
                              notchedOutline: classes.notchedOutline,
                            },
                          }}
                        />
                      </>
                    ) : editType === "Name" ? (
                      <TextField
                        placeholder="Shop Name"
                        value={name}
                        variant="outlined"
                        margin="normal"
                        fullWidth
                        id="Name"
                        label="Name"
                        name="Name"
                        onChange={(e) => setName(e.target.value)}
                        autoFocus
                        InputProps={{
                          classes: {
                            root: classes.cssOutlinedInput,
                            focused: classes.cssFocused,
                            notchedOutline: classes.notchedOutline,
                          },
                        }}
                      />
                    ) : editType === "Manager" ? (
                      <TextField
                        placeholder="Manager"
                        value={manager}
                        variant="outlined"
                        margin="normal"
                        fullWidth
                        id="Manager"
                        label="Manager"
                        name="Manager"
                        onChange={(e) => setManager(e.target.value)}
                        autoFocus
                        InputProps={{
                          classes: {
                            root: classes.cssOutlinedInput,
                            focused: classes.cssFocused,
                            notchedOutline: classes.notchedOutline,
                          },
                        }}
                      />
                    ) : editType === "Email" ? (
                      <TextField
                        placeholder="Email"
                        value={email}
                        variant="outlined"
                        margin="normal"
                        fullWidth
                        helperText={
                          emailError
                            ? "This email is either not valid or not supported."
                            : undefined
                        }
                        error={emailError}
                        id="Email"
                        label="Email"
                        name="Email"
                        onChange={(e) => setEmail(e.target.value)}
                        autoFocus
                        onFocus={() => setEmailError(false)}
                        FormHelperTextProps={{
                          classes: {
                            root: classes.helperText,
                            focused: classes.helperTextFocused,
                          },
                          style: {
                            textAlign: "left",
                            marginLeft: 0,
                          },
                        }}
                        InputProps={{
                          classes: {
                            root: classes.cssOutlinedInput,
                            focused: classes.cssFocused,
                            notchedOutline: classes.notchedOutline,
                          },
                        }}
                      />
                    ) : editType === "Phone" ? (
                      <TextField
                        placeholder="Phone"
                        value={phone}
                        variant="outlined"
                        margin="normal"
                        fullWidth
                        onFocus={() => setPhoneError(false)}
                        helperText={
                          phoneError
                            ? "This phone number is either not valid or not supported."
                            : undefined
                        }
                        error={phoneError}
                        FormHelperTextProps={{
                          classes: {
                            root: classes.helperText,
                            focused: classes.helperTextFocused,
                          },
                          style: {
                            textAlign: "left",
                            marginLeft: 0,
                          },
                        }}
                        id="Phone"
                        type="tel"
                        label="Phone"
                        name="Phone"
                        onChange={(e) => {
                          setPhone(e.target.value);
                        }}
                        autoFocus
                        InputProps={{
                          classes: {
                            root: classes.cssOutlinedInput,
                            focused: classes.cssFocused,
                            notchedOutline: classes.notchedOutline,
                          },
                        }}
                      />
                    ) : editType === "Time" ? (
                      <>
                        <Typography variant="body2" component="span">
                          Leaving an input field empty means the shop is closed
                          for business on that day of the week.
                        </Typography>
                        {TimeModalBody()}
                      </>
                    ) : (
                      <></>
                    )}
                  </GeneralModal.ContentArea>
                  <GeneralModal.ButtonArea>
                    <CancelButton
                      onClick={() => {
                        sortAndSetPickingHours();
                        setEditModalOpen(false);
                      }}
                    />
                    <SubmitButton
                      disabled={submitDisabled()}
                      onClick={handleSubmit}
                    />
                  </GeneralModal.ButtonArea>
                </GeneralModal>
                <RemoveImageModal
                  open={deleteImageModalOpen}
                  onClose={() => setDeleteImageModalOpen(false)}
                  onDelete={() => deleteImage(imageId)}
                />
                <ErrorModal
                  visible={errorModalOpen}
                  title="File not supported"
                  errorBody="Please upload a valid image file"
                  onClose={() => setErrorModalOpen(false)}
                />
              </Container>
            </>
          )}
        </Container>
        {/* <TrigerPrint
        print={print}
        printFunc={PrintLabels}
        printAgain={printAgain}
        printAgainFunc={PrintLabelsAgain}
      />
      <NumberOfPackageSelectionModal
        visible={numberOfPackageModalVisible}
        onClose={() => setNumberOfPackageModalVisible(false)}
        onSubmit={(packages: any) => PackagesSelected(packages)}
      /> */}
      </Box>
    </MuiPickersUtilsProvider>
  );
};
const useStyles = makeStyles((theme: ITheme) => ({
  imageContainer: {
    width: 145,
    height: 108,
    marginRight: 16,
    backgroundColor: "rgba(0, 0, 0, 0.08)",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
  },
  removeIconContainer: {
    backgroundColor: "rgba(255,255,255,0.72)",
    position: "relative",
    borderRadius: 20,
    height: 40,
    width: 40,
    textAlign: "center",
    float: "right",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginRight: 4,
    marginTop: 4,
    cursor: "pointer",
  },
  removeIcon: {
    width: 24,
    height: 24,
  },
  container: {
    display: "flex",
    justifyContent: "center",
  },
  imageList: {
    display: "flex",
    flexDirection: "row",
    marginTop: 15,
    paddingLeft: 0,
    paddingBottom: 18,
  },
  images: {
    width: 200,
    height: 150,
    marginRight: 10,
  },
  submitButton: {
    width: "80px",
    height: "48px",
    borderRadius: "8px",
    padding: "6px 16px",
    marginTop: 16,
    ...buttonHoverAndActive
  },
  cancelButton: {
    width: "80px",
    height: "48px",
    borderRadius: "8px",
    padding: "6px 16px",
    marginTop: 16,
    marginRight: "8px",
    ...textButtonHoverAndActive
  },
  cssOutlinedInput: {
    display: "flex",
    "&$cssFocused $notchedOutline": {
      border: `1px solid ${theme.palette.primary.main}`,

    },
  },

  cssFocused: {},

  notchedOutline: {
    border: "1px solid rgba(0, 0, 0, 0.12)",
  },
  printButtonText: {
    textTransform: "none",
    cursor: "pointer",
    padding: "6px 8px 6px 8px",
    "&:hover": {
      backgroundColor: theme.palette.secondary.main,
      borderRadius: 8,
    },
  },
  root: {
    maxWidth: "840px",
    paddingLeft: 0,
    paddingRight: 0,
  },
  detailsContainer: {
    marginTop: "24px",
    paddingLeft: 0,
    paddingRight: 0,
  },
  uMarginTop0: {
    marginTop: 0,
  },
  printableSection: {
    display: "none",
  },
  uMarginBottom12: {
    marginBottom: 12,
  },
  uPaddingTop20: {
    paddingTop: 20,
  },
  uploadIcon: {
    width: 18,
    height: 18,
    marginRight: 8,
    verticalAlign: "middle",
  },
  clearButton: {
    width: 24,
    height: 24,
    "&:hover": { backgroundColor: "transparent" },
  },
  clearIcon: {
    width: 18,
    height: 18,
  },
  helperText: {
    paddingTop: 4,
    fontWeight: 400,
    letterSpacing: 0.4,
  },
  helperTextFocused: {
    color: theme.palette.primary.main,
  },
}));
